import { useQuery } from "@apollo/client";
import { graphql } from "@/shared/gql";
import { UNBATCHED_CONTEXT, getPreloadQuery } from "@/shared/gql/apollo-client";
import {
  SourcingTagStatus,
  SourcingTenderEntryStatus,
} from "@/shared/gql/graphql";

const FetchSourcingTenderEntryCounts = graphql(`
  query FetchSourcingTenderEntryCounts(
    $needsApproval: SearchSourcingTenderEntriesInput!
    $tagsNeedReview: SearchSourcingTenderEntriesInput!
    $tagsQueued: SearchSourcingTenderEntriesInput!
    $published: SearchSourcingTenderEntriesInput!
    $missing: SearchSourcingTenderEntriesInput!
    $withoutSource: SearchSourcingTenderEntriesInput!
  ) {
    superAdmin {
      needsApproval: sourcingTenderEntries(input: $needsApproval) {
        paginatorInfo {
          total
        }
      }
      tagsNeedReview: sourcingTenderEntries(input: $tagsNeedReview) {
        paginatorInfo {
          total
        }
      }
      tagsQueued: sourcingTenderEntries(input: $tagsQueued) {
        paginatorInfo {
          total
        }
      }
      published: sourcingTenderEntries(input: $published) {
        paginatorInfo {
          total
        }
      }
      missing: sourcingTenderEntries(input: $missing) {
        paginatorInfo {
          total
        }
      }
      withoutSource: sourcingTenderEntries(input: $withoutSource) {
        paginatorInfo {
          total
        }
      }
    }
  }
`);

const FIRST_ROW = { page: 1, take: 1 };

const COUNTS_OPTIONS = {
  variables: {
    needsApproval: {
      status: SourcingTenderEntryStatus.NeedsApproval,
      paginator: FIRST_ROW,
    },
    tagsNeedReview: {
      tagStatus: SourcingTagStatus.NeedsReview,
      paginator: FIRST_ROW,
    },
    tagsQueued: { tagStatus: SourcingTagStatus.Queued, paginator: FIRST_ROW },
    published: { published: true, paginator: FIRST_ROW },
    missing: { missing: true, paginator: FIRST_ROW },
    withoutSource: { hasSource: false, paginator: FIRST_ROW },
  },
  context: UNBATCHED_CONTEXT,
};

export const preloadSourcingTenderEntryCounts = () => {
  getPreloadQuery()(FetchSourcingTenderEntryCounts, COUNTS_OPTIONS);
};

export const useFetchSourcingTenderEntryCounts = () => {
  const { data, loading } = useQuery(
    FetchSourcingTenderEntryCounts,
    COUNTS_OPTIONS,
  );
  const counts = data?.superAdmin;

  return {
    isLoading: loading && !counts,
    needsApproval: counts?.needsApproval.paginatorInfo.total,
    tagsNeedReview: counts?.tagsNeedReview.paginatorInfo.total,
    tagsQueued: counts?.tagsQueued.paginatorInfo.total,
    published: counts?.published.paginatorInfo.total,
    missing: counts?.missing.paginatorInfo.total,
    withoutSource: counts?.withoutSource.paginatorInfo.total,
  };
};
